/* Vehicle Fitment Finder widget — Armando 4x4 Australia
   Cascading Make > Model > Series > Year filter.
   Make always shows the full list. Model/Series narrow as you go.
   Year is hidden until Make + Model + Series (when it exists) are set,
   and is expanded from each product's Year range into individual years.
   If the widget has a results page configured, "Show Products" navigates
   there with the selections in the URL. Otherwise it filters in place —
   and on a page it's told is a results page, it also reads selections
   back OUT of the URL on load and shows matches immediately. */

(function () {
  var FIELDS = ['make', 'model', 'series', 'year'];

  function parseYears(yearStr) {
    if (!yearStr) return [];
    var s = ('' + yearStr).trim();

    var plus = s.match(/^(\d{4})\s*\+$/);
    if (plus) {
      var start = parseInt(plus[1], 10);
      var end = Math.max(new Date().getFullYear(), start);
      var out = [];
      for (var y = start; y <= end; y++) out.push('' + y);
      return out;
    }

    var range = s.match(/^(\d{4})\s*-\s*(\d{4})$/);
    if (range) {
      var a = parseInt(range[1], 10);
      var b = parseInt(range[2], 10);
      if (b < a) { var t = a; a = b; b = t; }
      var out2 = [];
      for (var y2 = a; y2 <= b; y2++) out2.push('' + y2);
      return out2;
    }

    var single = s.match(/^(\d{4})$/);
    if (single) return [single[1]];

    return [];
  }

  function init(widget) {
    var dataEl = widget.querySelector('[data-vf-data]');
    if (!dataEl) return;

    var products;
    try {
      products = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      console.error('Vehicle fitment widget: could not parse product data', e);
      return;
    }

    function splitList(str) {
      if (!str) return [];
      return ('' + str).split(',').map(function (s) {
        return s.trim();
      }).filter(function (s) {
        return !!s;
      });
    }

    products.forEach(function (p) {
      p.years = parseYears(p.year);
      p.series = splitList(p.series);
    });

    var resultsUrl = widget.getAttribute('data-vf-results-url') || '';

    var selects = {};
    FIELDS.forEach(function (f) {
      selects[f] = widget.querySelector('[data-vf-field="' + f + '"]');
    });
    var submitBtn = widget.querySelector('[data-vf-submit]');
    var resultsEl = widget.querySelector('[data-vf-results]');

    function currentSelections() {
      var sel = {};
      FIELDS.forEach(function (f) {
        sel[f] = selects[f] ? selects[f].value : '';
      });
      return sel;
    }

    function productMatchesField(product, field, value) {
      if (!value) return true;
      if (field === 'year') {
        return (product.years || []).indexOf(value) !== -1;
      }
      var val = product[field];
      if (Array.isArray(val)) return val.indexOf(value) !== -1;
      return val === value;
    }

    function productMatchesUpTo(product, selections, field) {
      var idx = FIELDS.indexOf(field);
      for (var i = 0; i < idx; i++) {
        if (!productMatchesField(product, FIELDS[i], selections[FIELDS[i]])) return false;
      }
      return true;
    }

    function allMakes() {
      var set = {};
      products.forEach(function (p) {
        (p.make || []).forEach(function (m) {
          if (m) set[m] = true;
        });
      });
      return Object.keys(set).sort();
    }

    function optionsFor(field, selections) {
      var set = {};
      products.forEach(function (p) {
        if (!productMatchesUpTo(p, selections, field)) return;
        var v = p[field];
        if (Array.isArray(v)) {
          v.forEach(function (item) {
            if (item) set[item] = true;
          });
        } else if (v) {
          set[v] = true;
        }
      });
      return Object.keys(set).sort();
    }

    function yearOptionsFor(selections) {
      // When a specific series is picked, work out that series' own real
      // year range from products that belong to ONLY that series (not
      // shared parts that also fit other series). That stops a part fitting
      // "RG & RG Facelift 2020+" from making later Facelift-only years show
      // up under a plain "RG" search, while still letting that same part
      // show up correctly in the actual results either way.
      var boundMin = null;
      var boundMax = null;
      var hasSingleSeriesMatch = false;
      if (selections.series) {
        products.forEach(function (p) {
          if (!productMatchesUpTo(p, selections, 'year')) return;
          if (!(p.series && p.series.length === 1)) return;
          hasSingleSeriesMatch = true;
          (p.years || []).forEach(function (y) {
            var n = parseInt(y, 10);
            if (boundMin === null || n < boundMin) boundMin = n;
            if (boundMax === null || n > boundMax) boundMax = n;
          });
        });
      }

      var set = {};
      products.forEach(function (p) {
        if (!productMatchesUpTo(p, selections, 'year')) return;
        (p.years || []).forEach(function (y) {
          if (hasSingleSeriesMatch) {
            var n = parseInt(y, 10);
            if (n < boundMin || n > boundMax) return;
          }
          set[y] = true;
        });
      });
      return Object.keys(set).sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
    }

    function renderOptions(field, options) {
      var select = selects[field];
      if (!select) return;
      var current = select.value;
      select.innerHTML = '';

      var anyOpt = document.createElement('option');
      anyOpt.value = '';
      anyOpt.textContent = 'Any';
      select.appendChild(anyOpt);

      options.forEach(function (opt) {
        var o = document.createElement('option');
        o.value = opt;
        o.textContent = opt;
        select.appendChild(o);
      });

      select.value = options.indexOf(current) !== -1 ? current : '';
    }

    function setFieldVisible(field, visible) {
      var select = selects[field];
      if (!select) return;
      var wrapper = select.closest('.vf-widget__field');
      if (wrapper) wrapper.hidden = !visible;
      select.disabled = !visible;
    }

    function refresh() {
      var selections = currentSelections();

      renderOptions('make', allMakes());
      selections.make = selects.make ? selects.make.value : selections.make;

      var modelOptions = selections.make ? optionsFor('model', selections) : [];
      renderOptions('model', modelOptions);
      selections.model = selects.model ? selects.model.value : selections.model;

      var seriesOptions = selections.make && selections.model ? optionsFor('series', selections) : [];
      renderOptions('series', seriesOptions);
      selections.series = selects.series ? selects.series.value : selections.series;

      var seriesReady = seriesOptions.length === 0 || !!selections.series;
      var yearReady = !!selections.make && !!selections.model && seriesReady;
      var yearOptions = yearReady ? yearOptionsFor(selections) : [];
      renderOptions('year', yearOptions);
      selections.year = selects.year ? selects.year.value : selections.year;
      setFieldVisible('year', yearReady);
    }

    FIELDS.forEach(function (f) {
      if (!selects[f]) return;
      selects[f].addEventListener('change', refresh);
    });

    refresh();

    function renderResults(matches) {
      if (!resultsEl) return;
      resultsEl.hidden = false;
      resultsEl.innerHTML = '';

      if (!matches.length) {
        var empty = document.createElement('p');
        empty.className = 'vf-widget__empty';
        empty.textContent = 'No matching products found. Try clearing one of the filters.';
        resultsEl.appendChild(empty);
        return;
      }

      var grid = document.createElement('div');
      grid.className = 'vf-widget__grid';

      matches.forEach(function (p) {
        var card = document.createElement('a');
        card.className = 'vf-widget__card';
        card.href = p.url;

        var img = document.createElement('div');
        img.className = 'vf-widget__card-image';
        if (p.image) {
          img.style.backgroundImage = 'url(' + p.image + ')';
        }
        if (p.compareAtPrice || p.preOrder) {
          var badges = document.createElement('div');
          badges.className = 'vf-widget__card-badges';
          if (p.compareAtPrice) {
            var saleBadge = document.createElement('span');
            saleBadge.className = 'vf-widget__card-badge';
            saleBadge.textContent = 'Sale';
            badges.appendChild(saleBadge);
          }
          if (p.preOrder) {
            var preOrderBadge = document.createElement('span');
            preOrderBadge.className = 'vf-widget__card-badge vf-widget__card-badge--preorder';
            preOrderBadge.textContent = 'Pre-Order';
            badges.appendChild(preOrderBadge);
          }
          img.appendChild(badges);
        }

        var title = document.createElement('p');
        title.className = 'vf-widget__card-title';
        title.textContent = p.title;

        var price = document.createElement('p');
        price.className = 'vf-widget__card-price';
        if (p.compareAtPrice) {
          var comparePrice = document.createElement('span');
          comparePrice.className = 'vf-widget__card-price-compare';
          comparePrice.textContent = p.compareAtPrice;
          var salePrice = document.createElement('span');
          salePrice.className = 'vf-widget__card-price-sale';
          salePrice.textContent = p.price;
          price.appendChild(comparePrice);
          price.appendChild(salePrice);
        } else {
          price.textContent = p.price;
        }

        card.appendChild(img);
        card.appendChild(title);
        card.appendChild(price);
        grid.appendChild(card);
      });

      resultsEl.appendChild(grid);
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function buildQueryParams(selections) {
      var params = new URLSearchParams();
      FIELDS.forEach(function (f) {
        if (selections[f]) params.set(f, selections[f]);
      });
      return params;
    }

    function performSearch() {
      var selections = currentSelections();
      var hasAnySelection = FIELDS.some(function (f) {
        return selections[f];
      });

      if (resultsUrl) {
        if (!hasAnySelection) return;
        var params = buildQueryParams(selections);
        var sep = resultsUrl.indexOf('?') === -1 ? '?' : '&';
        window.location.href = resultsUrl + sep + params.toString();
        return;
      }

      if (!hasAnySelection) {
        if (resultsEl) {
          resultsEl.hidden = true;
          resultsEl.innerHTML = '';
        }
        return;
      }

      var matches = products.filter(function (p) {
        return FIELDS.every(function (f) {
          return productMatchesField(p, f, selections[f]);
        });
      });

      renderResults(matches);
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', performSearch);
    }

    function applyFromQueryString() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return false;
      }
      var any = FIELDS.some(function (f) {
        return !!params.get(f);
      });
      if (!any) return false;

      FIELDS.forEach(function (f) {
        refresh();
        var v = params.get(f);
        if (v && selects[f]) {
          var has = Array.prototype.some.call(selects[f].options, function (o) {
            return o.value === v;
          });
          if (has) selects[f].value = v;
        }
      });
      refresh();
      return any;
    }

    var appliedFromUrl = applyFromQueryString();
    if (appliedFromUrl && !resultsUrl) {
      performSearch();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vf-widget]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();